import * as React from 'react';

/**
 * Phenix RTS logo with text as an inline SVG
 */
export const Logo = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    id="site-logo"
    viewBox="0 0 298.49 108.83"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <defs>
      <linearGradient
        id="a"
        x1="246.37"
        y1="35.87"
        x2="265.4"
        y2="35.87"
        gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#e3317c" />
        <stop offset="1" stopColor="#a02365" />
      </linearGradient>
      <linearGradient
        id="b"
        x1="225.24"
        y1="24.74"
        x2="245.69"
        y2="24.74"
        gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#e3317c" />
        <stop offset="1" stopColor="#9d2366" />
      </linearGradient>
    </defs>
    <path
      className="logo-a"
      d="M19.34 38.75H8.22A8.19 8.19 0 0 0 0 47.05v43.23h6.42V76.34a6.28 6.28 0 0 0 1.8.16h11.12a8.3 8.3 0 0 0 8.3-8.31V47.05a8.25 8.25 0 0 0-8.3-8.3zm1.8 28.9a2.48 2.48 0 0 1-2.58 2.43H8.85a2.53 2.53 0 0 1-2.43-2.59V47.91A2.75 2.75 0 0 1 9 45.17h9.8a2.47 2.47 0 0 1 2.34 2.59zM58 38.75H46.91a6.32 6.32 0 0 0-1.8.16v-14h-6.43V76.5h6.43V47.76a2.48 2.48 0 0 1 2.43-2.59h9.7a2.48 2.48 0 0 1 2.59 2.43v28.9h6.5V47.05a8.26 8.26 0 0 0-8.33-8.3zM96.71 38.75H85.59a8.19 8.19 0 0 0-8.22 8.3v21.14a8.19 8.19 0 0 0 8.22 8.31h11.12a8.31 8.31 0 0 0 8.29-8.31v-2.73h-6.5v2.19a2.49 2.49 0 0 1-2.59 2.43h-9.69a2.52 2.52 0 0 1-2.43-2.59v-6.66H105V47.05a8.26 8.26 0 0 0-8.29-8.3zm1.81 15.66H83.79v-6.5a2.75 2.75 0 0 1 2.58-2.74h9.8a2.47 2.47 0 0 1 2.35 2.59zM135.4 38.75h-19.35V76.5h6.43V45.17h12.14a2.48 2.48 0 0 1 2.58 2.43v28.9h6.5V47.05a8.25 8.25 0 0 0-8.3-8.3zM155 24.9h6.33v10.82H155zM155 76.5h6.33V38.9l-6.33-.15V76.5zM188.23 57.18l10.65-18.59h-6.85l-7.11 12.76-7.1-12.76h-6.85l10.64 18.59-10.98 19.29h6.63l7.66-13.56 7.66 13.56h6.63l-10.98-19.29z"
    />
    <path
      className="logo-b"
      d="M233.53 89.71c.18.05.36.12.51.15l5.05 1.28L245.42 75z"
    />
    <path
      className="logo-c"
      d="M239.61 91.5c4.42-3 8.34-4.71 12.76-7.71L245.69 76c-2.18 5.55-3.88 9.89-6.08 15.5zM233.17 90.12q-2 1.69-3.92 3.4c-3.23 2.8-17.6 12.51-20.83 15.31 6.36-3.48 23.85-13.86 30.21-17.33l-5.38-1.37z"
    />
    <path
      className="logo-b"
      d="M275.19 50.14c-2.46 1.37-4.93 2.72-7.38 4.09l15.3-.71z"
    />
    <path className="logo-c" d="M283.51 50.14h-7.18l7.52 3.2-.21-3.18z" />
    <path
      className="logo-b"
      d="M245.94 75.5l6.73 7.9c.23-.47.45-.94.68-1.42q6.41-13.23 12.79-26.44z"
    />
    <path
      className="logo-d"
      d="M284.1 50.12c.08 1.09.15 2.18.23 3.27q7.07-2.4 14.16-4.78z"
    />
    <path
      className="logo-c"
      d="M269.31 54.61l-2.28.1-.12.25c-.23.47-.44.93-.66 1.38q-6.42 13.25-12.81 26.49 3.84-3.7 7.7-7.39l22.41-21.5-11.55.54z"
    />
    <path
      d="M260.07 21.86c-.27-1.64-.54-3.28-.8-4.92q-3.75 7.2-7.47 14.41-2.3 4.41-4.58 8.83c-.28.54-.56 1.09-.85 1.63q9.52 6.49 19 13-2.64-16.48-5.3-32.95z"
      style={{ fill: 'url(#a)' }}
    />
    <path
      d="M234.54 11.13L230.49 0q-1.73 16.25-3.44 32.48-.9 8.51-1.81 17l20.45-7.71z"
      style={{ fill: 'url(#b)' }}
    />
    <path
      className="logo-g"
      d="M245.93 74.76l19.44-19.32-19.08-13zM225.26 50q1.62 6.49 3.25 13 8.37-10.27 16.75-20.53z"
    />
    <path className="logo-d" d="M245.4 74.86q.18-16.11.37-32.21l-17 20.85z" />
  </svg>
);

/**
 * Phenix RTS logo (bird only) as an inline SVG
 */
export const LogoMark = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    id="logo-mark"
    viewBox="0 0 90.06 108.83"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <defs>
      <linearGradient
        id="a"
        x1="37.95"
        y1="35.87"
        x2="56.98"
        y2="35.87"
        gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#e3317c" />
        <stop offset="1" stopColor="#a02365" />
      </linearGradient>
      <linearGradient
        id="b"
        x1="16.82"
        y1="24.74"
        x2="37.27"
        y2="24.74"
        gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#e3317c" />
        <stop offset="1" stopColor="#9d2366" />
      </linearGradient>
    </defs>
    <path
      className="logo-mark-a"
      d="M25.11 89.71c.18.05.36.12.51.15l5.05 1.28Q33.82 83.07 37 75z"
    />
    <path
      className="logo-mark-b"
      d="M31.18 91.5c4.43-3 8.34-4.71 12.76-7.71-2.21-2.61-4.45-5.23-6.67-7.84zM24.75 90.12q-2 1.69-3.92 3.4C17.6 96.32 3.22 106 0 108.83 6.35 105.35 23.85 95 30.2 91.5l-5.38-1.37z"
    />
    <path className="logo-mark-a" d="M66.77 50.14l-7.39 4.09 15.31-.71z" />
    <path
      className="logo-mark-b"
      d="M75.09 50.14h-7.18l7.52 3.2c-.07-1.06-.15-2.12-.22-3.18z"
    />
    <path
      className="logo-mark-a"
      d="M37.52 75.5q3.36 4 6.73 7.9c.23-.47.45-.94.68-1.42q6.39-13.23 12.78-26.44z"
    />
    <path
      className="logo-mark-c"
      d="M75.68 50.12c.08 1.09.15 2.18.22 3.27l14.16-4.78z"
    />
    <path
      className="logo-mark-b"
      d="M60.89 54.61l-2.28.1-.12.25-.67 1.38Q51.41 69.59 45 82.83l7.71-7.39 22.4-21.5-11.56.54z"
    />
    <path
      d="M51.64 21.86c-.26-1.64-.53-3.28-.8-4.92q-3.73 7.2-7.47 14.41l-4.58 8.83c-.28.54-.55 1.09-.84 1.63q9.52 6.49 19 13z"
      style={{ fill: 'url(#a)' }}
    />
    <path
      d="M26.11 11.13c-1.34-3.71-2.7-7.42-4-11.13l-3.49 32.48-1.8 17 20.45-7.71-11.16-30.64z"
      style={{ fill: 'url(#b)' }}
    />
    <path
      className="logo-mark-f"
      d="M37.51 74.76l19.43-19.32-19.07-13zM16.83 50q1.64 6.49 3.26 13 8.36-10.27 16.75-20.53z"
    />
    <path className="logo-mark-c" d="M37 74.86q.18-16.11.37-32.21l-17 20.85z" />
  </svg>
);
